module.exports = __webpack_public_path__ + "static/media/door-hanger.b0f64274.svg";